import teamComponent from '../components/team.svelte'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {},
	finalize() {
		const $teamSection = $('#teamSection')
		if ($teamSection.length) {
			new teamComponent({
				target: $teamSection[0],
				props: $teamSection.data(),
			})
		}

		//animation / gsap
		//hero
		let $heroH1 = $('.team-intro > h1')[0]
		if ($heroH1) {
			gsap.fromTo(
				'.team-intro > h1',
				{
					y: -50,
					opacity: 0,
				},
				{
					scrollTrigger: '.team-intro > h1',
					delay: 0.5,
					duration: 0.5,
					y: 0,
					opacity: 1,
				}
			)
		}
		let $heroP = $('.team-intro .team-intro-content-wrap p')
		if ($heroP.length) {
			document
				.querySelectorAll('.team-intro .team-intro-content-wrap p')
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: -50, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							x: 0,
							opacity: 1,
						}
					)
				})
		}
		let $heroH2 = $('.team-intro .team-intro-content-wrap h2')
		if ($heroH2.length) {
			document
				.querySelectorAll('.team-intro .team-intro-content-wrap h2')
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: 50, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							x: 0,
							opacity: 1,
						}
					)
				})
		}
		let $heroBlueLine = $(
			'.team-intro > .team-intro-content-wrap > .blue-line'
		)[0]
		if ($heroBlueLine) {
			gsap.fromTo(
				'.team-intro > .team-intro-content-wrap > .blue-line',
				{
					y: 50,
					opacity: 0,
				},
				{
					scrollTrigger: '.team-intro > .team-intro-content-wrap > .blue-line',
					delay: 0.5,
					duration: 0.5,
					y: 0,
					opacity: 1,
				}
			)
		}

		let $teamPlaneElement = $('#teamPlaneElement')[0]
		if ($teamPlaneElement) {
			gsap.fromTo(
				'#teamPlaneElement',
				{
					x: 50,
				},
				{
					scrollTrigger: '#teamPlaneElement',
					delay: 0.5,
					duration: 0.5,
					x: 0,
				}
			)
		}

		if ($teamSection) {
			gsap.fromTo(
				'#teamSection',
				{
					y: 50,
				},
				{
					scrollTrigger: '#teamSection',
					delay: 0.5,
					duration: 0.5,
					y: 0,
				}
			)
		}

		// planes
		let $oddPlanes = $(
			'.inner-content-wrap .coastal-text-media-block:nth-of-type(odd) .white-line svg, .inner-content-wrap .coastal-text-block:nth-of-type(odd) .white-line svg'
		)
		if ($oddPlanes.length) {
			document
				.querySelectorAll(
					'.inner-content-wrap .coastal-text-media-block:nth-of-type(odd) .white-line svg, .inner-content-wrap .coastal-text-block:nth-of-type(odd) .white-line svg'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: 150 },
						{
							scrollTrigger: item,
							delay: 0,
							duration: 0.5,
							x: -150,
						}
					)
				})
		}
		let $evenPlanes = $(
			'.inner-content-wrap .coastal-text-media-block:nth-of-type(even) .white-line svg, .inner-content-wrap .coastal-text-block:nth-of-type(even) .white-line svg'
		)
		if ($evenPlanes.length) {
			document
				.querySelectorAll(
					'.inner-content-wrap .coastal-text-media-block:nth-of-type(even) .white-line svg, .inner-content-wrap .coastal-text-block:nth-of-type(even) .white-line svg'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ y: 0 },
						{
							scrollTrigger: item,
							delay: 0,
							duration: 0.5,
							y: 150,
						}
					)
				})
		}
	},
}
